export enum UserRole {
	ADMIN = 'admin',
	COORDINATOR = 'coordinator',
}
